import React from 'react'
import Common from './../../api/common'
import Bottom from './../../api/bottom'
import solution_banner_4_cp from './../../imgs/solution_banner_4_cp.png'
import solution_banner_4_js from './../../imgs/solution_banner_4_js.png'
import solution_banner_4_kf from './../../imgs/solution_banner_4_kf.png'
import solution_banner_5 from './../../imgs/solution_banner_5.png'
import './style.less'
export default class solve_plan extends React.Component {
    componentDidMount(){
        var currentTop = window.pageYOffset, top = 0, requestId;
        function step(timestamp) {
            currentTop -= 40;
            if (currentTop >= top) {
                window.scrollTo(0, currentTop);
                requestId = window.requestAnimationFrame(step);
            } else {
                window.cancelAnimationFrame(requestId);
            }
        }
        window.requestAnimationFrame(step);
        //console.log(this.props.history.location.search.substr(this.props.history.location.search.length-1 ,1))
        this.setState({active:this.props.history.location.search.substr(this.props.history.location.search.length-1 ,1)||1})
    }
    state={
        active:1
    }
    render() {
        const {active}=this.state
        return (<div className='solve_plan'>
            <Common history={this.props.history}></Common>
            <div className="header-banner">
                <div className="zixun" onClick={()=>{
                    this.props.history.push({pathname:'/consult'})
                }}>方案咨询</div>
            </div>
            
            <div className="con">
                <div className="top">
                    <ul>
                        <li className={`${active==1?'active':''}`}>
                            <h3>智慧社区</h3>
                            <p>Smart Community</p>
                        </li>
                        {/* <li className={`${active==2?'active':''}`}>
                            <h3>智慧园区</h3>
                            <p>Smart Park</p>
                        </li>
                        <li className={`${active==3?'active':''}`}>
                            <h3>智慧校园</h3>
                            <p>Smart Campus</p>
                        </li>
                        <li className={`${active==4?'active':''}`}>
                            <h3>智慧城市</h3>
                            <p>Smart city</p>
                        </li> */}
                    </ul>
                </div>
                <div className="con-1">
                    <div className="tit">
                        <h3>产品创新理念管理社区，物业服务全面预算控制</h3>
                        <p>彩之云把社区服务做到家</p>
                        <div className="box">
                            <ol>
                                <li>【智能停车】 自动识别车牌号，轻松过闸</li>
                                <li>【智能门禁】 蓝牙开门，手机就是社区门禁卡</li>
                                <li>【基础物业】 智能社区为您提供臻美生活</li>
                                <li>【周边商圈】1公里内优惠买单</li>
                                <li>【社区公告】 及时推送、随时掌握信息</li>
                                <li>【线上缴费】 随时查询欠费情况，费用随时缴</li>
                                <li>【周边新鲜事】 打造社区邻里圈，增进邻里感情，提升受社区幸福感</li>
                                <li>【便民服务】 线上预约，轻松服务，学习生活两不误</li>
                                <li>【健康服务】 健康我保障</li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="con-2">
                    <div className="tit">
                        <h3>物业运营管理效率高，人财物事统一集中管控</h3>
                        <p>北斗七星—由安全、维修、能源、保洁、绿化、缴费、投诉组成，将北斗七星产品灵活组合，开创全新的合作方式</p>
                    </div>
                </div>
                <div className="con-3">
                <div className="tit">
                        <h3>互联网物业服务云平台，物业服务产品化、互联网化</h3>
                        <p>彩之云打造管理数字化、办公智能化、生活优质化，大数据应用化的智慧生活。</p>
                    </div>
                </div>
                <div className="con-4">
                <div className="tit">
                        <h3>平台赋能，把社区服务做到家</h3>
                        <p>Platform Enabling, Make Community Service Home</p>
                    </div>
                    <ul>
                        <li><img src={solution_banner_4_cp} alt=""/></li>
                        <li><img src={solution_banner_4_js} alt=""/></li>
                        <li><img src={solution_banner_4_kf} alt=""/></li>
                    </ul>
                </div>
                <div className="con-5">
                <div className="tit">
                        <h3>应用场景</h3>
                        <p>Platform Enabling, Make Community Service Home</p>
                        <img src={solution_banner_5} alt=""/>
                    </div>
                </div>
            </div>
            <div style={{ position: 'fixed', bottom: 0, width: '100%' }}><Bottom></Bottom></div>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/pages/solve_plan/solve_plan.jsx